<template>
  <div class="sign-pg">
    <div class="sign-row">
      <div class="confirm-email">
        <template v-if="success">
          <p>
            {{ $t("Регистрация успешно завершена!") }}
          </p>
          <p>
            <router-link
              :to="$i18nRoute({ name: 'profile' })">
              {{ $t("Личный кабинет") }}
            </router-link>
          </p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import User from "@/model/user";
import axios from 'axios'
import {Trans} from "@/plugins/Translation";

export default {
  data: () => ({
    token: null,
    success: false
  }),
  created() {
    this.token = this.$route.params.token
    User.confirmRegistration(this.token)
      .then((response) => {
        const result = response.data
        this.$store.dispatch('setUserToken', result)
        this.success = true
      })
      .catch((error) => {
        //тут будем обрабатывать ошибки
        this.$router.push(Trans.i18nRoute({
          name: 'error',
          params: {
            status: error.response.status
          }
        }))
      })
  },
}
</script>

<style scoped>
</style>
